import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalModule } from 'ngx-bootstrap/modal';

import { MaterialModule } from '../../project/material.module';
import { TranslationModule } from '../../shared/models/translation.module';
import { SharedModule } from '../../shared/shared.module';
import { ChatService } from './chat-service';
import { InstructionDialogComponent } from './instruction-dialog/instruction-dialog.component';
import { MaintenanceChatDialogComponent } from './maintenance-chat-dialog/maintenance-chat-dialog.component';
import { MaintenanceRequestComponent } from './maintenance-request.component';
import { MaintenanceRequestService } from './maintenance-request.service';
import { QuoteDialog } from './quote-dialog/quote-dialog.component';
import { ViewMaintenanceRequestDialogComponent } from './view-request-dialog/view-maintenance-request-dialog.component';
import { PopoverModule } from 'ngx-bootstrap/popover';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),

    TranslationModule,
    SharedModule,
  ],
  declarations: [
    QuoteDialog,
    MaintenanceRequestComponent,
    InstructionDialogComponent,
    MaintenanceChatDialogComponent,
    ViewMaintenanceRequestDialogComponent
  ],
  exports: [],
  providers: [
    ChatService,
    MaintenanceRequestService
  ],
  entryComponents: [
    QuoteDialog,
    InstructionDialogComponent,
    MaintenanceChatDialogComponent,
    ViewMaintenanceRequestDialogComponent
  ]
})
export class MaintenanceRequestModule {

}